export const addGroupKeyboardAccessibility = (group) => {
  group?.forEach((item) => {
    if (item.classList.contains('sendbird-message-content')) item.setAttribute('tabindex', '-1');
    item.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        const currentIndex = Array.from(group).indexOf(e.currentTarget);

        if (e.key === 'ArrowUp') {
          const prevIndex = currentIndex - 1;
          if (prevIndex >= 0) {
            group[prevIndex].focus();
          }
        } else if (e.key === 'ArrowDown') {
          const nextIndex = currentIndex + 1;
          if (nextIndex < group.length) {
            group[nextIndex].focus();
          }
        }
      }
    });
  });
};

export const removeUnnecessaryAttrs = () => {
  const unnecessaryAttrs = document.querySelectorAll('.sendbird-avatar, .sendbird-icon');
  unnecessaryAttrs.forEach((el) => {
    el.removeAttribute('role');
    el.removeAttribute('tabindex');
  });
};

export const setAriaCurrent = (channelPreviews) => {
  let activeChannelExists;

  channelPreviews.forEach((preview) => {
    preview.setAttribute('tabindex', '-1');
    preview.setAttribute('aria-current', 'false');

    if (preview.classList.contains('channel-preview--btn__active')) {
      activeChannelExists = true;
      preview.setAttribute('tabindex', '0');
      preview.setAttribute('aria-current', 'true');
    }
  });

  if (!activeChannelExists) {
    channelPreviews[0]?.setAttribute('tabindex', '0');
    channelPreviews[0]?.setAttribute('aria-current', 'true');
  }
};

export const addChannelLabels = () => {
  const messages = document.querySelectorAll('.sendbird-message-content');

  messages?.forEach((message) => {
    const isOutgoing = message?.classList.contains('outgoing');
    const hasDatestamp = message?.previousSibling?.classList.contains('sendbird-separator');

    const senderName = isOutgoing ? 'You' : message?.querySelector('.sendbird-message-content__middle__sender-name')?.innerHTML;
    const messageContent = message?.querySelector('.sendbird-text-message-item-body')?.innerHTML;
    const timestamp = isOutgoing
      ? message?.querySelector('.sendbird-message-status__text')?.innerHTML
      : message?.querySelector('.sendbird-message-content__middle__body-container__created-at')?.innerHTML;
    const datestamp = hasDatestamp ? message?.previousSibling.querySelector('.sendbird-label')?.innerHTML : '';
    const notDelivered = message?.querySelector('.sendbird-icon-error') ? '- Not delivered' : '';

    const labelParts = [];

    if (senderName) {
      labelParts.push(`${senderName} sent`);
    }
    if (messageContent) {
      labelParts.push(messageContent);
    }
    if (notDelivered) {
      labelParts.push(notDelivered);
    }
    if (timestamp) {
      labelParts.push(`at ${timestamp}`);
    }
    if (datestamp) {
      labelParts.push(`on ${datestamp}`);
    }

    const label = labelParts.join(' ');

    message.setAttribute('role', 'group');
    message.setAttribute('aria-label', label);

    message.querySelectorAll(':scope > div')?.forEach((el) => el.setAttribute('aria-hidden', 'true'));

    if (notDelivered) message?.querySelector('.sendbird-icon-error').setAttribute('aria-label', 'Error');
  });
};

export const removeReadReceipts = () => {
  const readReceipts = document.querySelectorAll('.sendbird-message-content__middle__body-container__created-at');
  let lastReadFound = false;
  let lastSentFound = false;

  // eslint-disable-next-line no-plusplus
  for (let i = readReceipts.length - 1; i >= 0; i--) {
    const readIcon = readReceipts[i].querySelector('.sendbird-icon-color--read');
    const sentIcon = readReceipts[i].querySelector('.sendbird-icon-color--sent');
    if ((lastReadFound && readIcon) || (lastSentFound && sentIcon)) {
      readReceipts[i].remove();
    } else {
      if (readIcon) {
        lastReadFound = true;
      }
      if (sentIcon) {
        lastSentFound = true;
      }
    }
  }
};

export const addSkipBtnFunctionality = () => {
  const skipBtn = document.querySelector('#skip-to-last-message');

  skipBtn?.addEventListener('click', () => {
    const messages = document.querySelectorAll('.sendbird-message-content');
    const lastMessage = messages[messages.length - 1];
    lastMessage.focus();
  });
};

export const addScrollToBottomLabel = () => {
  const scrollToBottomBtn = document.querySelector('.sendbird-conversation__scroll-bottom-button');
  scrollToBottomBtn?.setAttribute('aria-label', 'Scroll to bottom');
};

export function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    return observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

export function addChannelListAccessibility() {
  const channelPreviews = document.querySelectorAll('.channel-preview--btn');
  addGroupKeyboardAccessibility(channelPreviews);
  setAriaCurrent(channelPreviews);
}

export function addChannelAccessibility() {
  waitForElm('.sendbird-conversation__messages').then(() => {
    const messages = document.querySelectorAll('.sendbird-message-content');
    addGroupKeyboardAccessibility(messages);
    removeUnnecessaryAttrs();
    addChannelLabels();
    addSkipBtnFunctionality();
    removeReadReceipts();
  });

  waitForElm('.sendbird-conversation__scroll-bottom-button').then(() => {
    addScrollToBottomLabel();
  });
}
